export const WIDGET_NAMES = {
  TOTAL_INBOUND_CALLS: 'TotalInboundCalls',
  TOTAL_OUTBOUND_CALLS: 'TotalOutboundCalls',
  TOTAL_INBOUND_CALLS_HANDLED: 'TotalInboundCallsHandled',
  TOTAL_INBOUND_CALLS_MISSED: 'TotalInboundCallsMissed',
  TOTAL_OUTBOUND_CALLS_HANDLED: 'TotalOutboundCallsHandled',
  TOTAL_OUTBOUND_CALLS_MISSED: 'TotalOutboundCallsMissed',
  TOTAL_INBOUND_DIRECT_CALLS: 'TotalInboundDirectCalls',
  TOTAL_INTERNAL_CALLS: 'TotalInternalCalls',
  TOTAL_ABANDONED_CALLS: 'TotalAbandonedCalls',
  TOTAL_TRANSFERRED_CALLS: 'TotalTransferredCalls',
  TOTAL_INBOUND_TRANSFERRED_CALLS: 'TotalInboundTransferredCalls',
  TOTAL_FORWARDED_CALLS: 'TotalForwardedCalls',
  TOTAL_MISSED_CALLS: 'TotalMissedCalls',
  TRANSFERRED_RATE: 'TransferredRate',
  SLA: 'SLA',
  CALL_ABANDONED_RATE: 'CallAbandonedRate',
  AVERAGE_WAITING_TIME: 'AverageWaitingTime',
  AVERAGE_HANDLE_TIME: 'AverageHandleTime',
  AVERAGE_SPEED_OF_ANSWER: 'AverageSpeedOfAnswer',
  INBOUND_STATUS_DISTRIBUTION: 'InboundCallStatusDistribution',
  OUTBOUND_STATUS_DISTRIBUTION: 'OutboundCallStatusDistribution',
  INBOUND_DIRECT_STATUS_DISTRIBUTION: 'InboundDirectCallStatusDistribution',
  CALLS_HANDLED_BY_QUEUE: 'CallHandledByCallQueue',
  CALL_VOLUME_TOTAL: 'CallVolume',
  TOTAL_ACTIVE_AGENTS: 'TotalActiveAgents',
  TOP_PERFORMER: 'TopPerformer',
  AVERAGE_CALLS_PER_AGENT: 'AverageCallsPerAgent',
  CALL_VOLUME: 'CallVolume',
  CALL_VOLUME_TREND: 'CallVolumeTrend',
  CALL_STATUS_DISTRIBUTION_TREND: 'CallStatusDistributionTrend',
  AVERAGE_WAITING_TIME_TREND: 'AverageWaitingTimeTrend',
  AVERAGE_WAITING_TIME_TREND_INBOUND_DIRECT: 'AverageWaitingTimeTrendInboundDirect',
  AVERAGE_HANDLING_TIME_TREND: 'AverageHandlingTimeTrend',
  AVERAGE_HANDLING_TIME_TREND_INBOUND_DIRECT: 'AverageHandlingTimeTrendInboundDirect',
  AVERAGE_SPEED_OF_ANSWER_INBOUND_DIRECT: 'AverageSpeedOfAnswerInboundDirect',
  SLA_TREND: 'SLATrend',
  SLA_BY_CALL_QUEUE: 'SLAByCallQueue',
  CALL_DETAIL_OVERVIEW: 'CallDetailOverview',
  AGENT_PERFORMANCE: 'AgentPerformance',
  CALL_JOURNEY: 'CallJourney',
  SLA_RANKING: 'SLARanking',
  STATUS_OVER_TIME: 'StatusOverTime',
  AVERAGE_CALLS_PER_AGENT_TREND: 'AverageCallsPerAgentTrend',
  CALL_VOLUME_DISTRIBUTION: 'CallVolumeDistribution',
  AVERAGE_CALLS_PER_AGENT_CQ: 'AverageCallsPerAgentCallQueueInsight'
};

export const WIDGET_IDS = {
  TOTAL_INBOUND_CALLS: 1,
  TOTAL_OUTBOUND_CALLS: 2,
  TOTAL_INBOUND_CALLS_HANDLED: 3,
  TOTAL_INBOUND_CALLS_MISSED: 4,
  TOTAL_OUTBOUND_CALLS_HANDLED: 5,
  TOTAL_OUTBOUND_CALLS_MISSED: 6,
  TOTAL_INTERNAL_CALLS: 7,
  TOTAL_ABANDONED_CALLS: 8,
  TOTAL_INBOUND_TRANSFERRED_CALLS: 40,
  TOTAL_TRANSFERRED_CALLS: 41,
  TOTAL_FORWARDED_CALLS: 9,
  TRANSFERRED_RATE: 10,
  SLA: 11,
  CALL_ABANDONED_RATE: 12,
  AVERAGE_WAITING_TIME: 13,
  AVERAGE_HANDLE_TIME: 14,
  AVERAGE_SPEED_OF_ANSWER: 15,
  TOTAL_ACTIVE_AGENTS: 16,
  TOP_PERFORMER: 17,
  AVERAGE_CALLS_PER_AGENT: 18,
  CALL_VOLUME: 19,
  INBOUND_STATUS_DISTRIBUTION: 20,
  OUTBOUND_STATUS_DISTRIBUTION: 21,
  CALLS_HANDLED_BY_QUEUE: 22,
  SLA_RANKING: 23,
  STATUS_OVER_TIME: 24,
  CALL_VOLUME_TREND: 25,
  CALL_STATUS_DISTRIBUTION_TREND: 26,
  AVERAGE_WAITING_TIME_TREND: 36,
  AVERAGE_WAITING_TIME_TREND_INBOUND_DIRECT: 37,
  AVERAGE_HANDLING_TIME_TREND: 27,
  AVERAGE_HANDLING_TIME_TREND_INBOUND_DIRECT: 38,
  AVERAGE_SPEED_OF_ANSWER_INBOUND_DIRECT: 39,
  SLA_TREND: 28,
  SLA_BY_CALL_QUEUE: 29,
  CALL_DETAIL_OVERVIEW: 30,
  AGENT_PERFORMANCE: 31,
  CALL_JOURNEY: 32,
  AVERAGE_CALLS_BY_AGENTS: 33,
  CALL_VOLUME_DISTRIBUTION: 34,
  INBOUND_DIRECT_STATUS_DISTRIBUTION: 35,
  TOTAL_INBOUND_DIRECT_CALLS: 42,
  AVERAGE_CALLS_PER_AGENT_CQ: 43
};
